import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import './manufactureinsurance.scss'
import { images } from '../../../utils/customFn'

const ManufacturingInsurance = () => {
    return (
        <>
            {/* talk section */}
            <div className='lets-talk-manufacture'>
                <Row>
                    <Col sm={12} md={7} lg={8} xl={8}>
                        <div className='left-details'>
                            <div className='Heading'>
                                <h3>Manufacturers insurance designed to fit your business</h3>
                            </div>
                            <div className='text'>
                                <p>Our customizable manufacturing insurance policies provide coverage options and risk controls that help protect your business. The service you receive from Sentry is backed by more than 120 years of experience—and our Midwestern values inform everything we do.</p>
                            </div>
                            <NavLink to={''}>View resources</NavLink>
                        </div>
                    </Col>
                    <Col sm={12} md={5} lg={4} xl={4}>
                        <div className='talk-right'>
                            <h3>Let's talk</h3>
                            <p>We offer local service and customized coverage. Let us put our industry knowledge to work for you.</p>
                            <button className='request-btn'>Request a quote</button>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* manufature banner column */}
            <div className='common-top-data'>
                <Row>
                    <Col sm={12} md={4} lg={4} xl={4}>
                        <div className='right-image'>
                            <img src={images['Manufacturing-workers-hand.avif']} alt='media' />
                        </div>
                    </Col>
                    <Col sm={12} md={8} lg={8} xl={8}>
                        <div className='left-details'>
                            <div className='Heading'>
                                <h3>Manufacturing insurance with a personal touch</h3>
                            </div>
                            <div className='text'>
                                <p>Our experienced agents are ready to learn about you—and the unique risks your manufacturing business faces. They’ll work with you to develop an insurance policy for your manufacturing business that helps protect your company and your employees.</p>
                                <p>We believe our business is to get to know your business. That’s exactly what we do.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* manufature heading */}
            <div className='lets-talk-manufacture'>
                <Row>
                    <Col sm={12} md={12} lg={12} xl={8}>
                        <div className='left-details'>
                            <div className='Heading'>
                                <h3>Manufacturing insurance for small businesses and large companies</h3>
                            </div>
                            <div className='text'>
                                <p>Our customizable manufacturing insurance policies provide coverage options and risk controls that help protect your business. The service you receive from Sentry is backed by more than 120 years of experience—and our Midwestern values inform everything we do.</p>
                            </div>
                            <NavLink to={''}>View resources</NavLink>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* insurace list */}
            <div className='common-top-data'>
                <Row>
                    <Col sm={12} md={8} lg={8} xl={8}>
                        <div className='left-details'>
                            <div className='Heading'>
                                <h3>Who needs manufacturing insurance?</h3>
                            </div>
                            <div className='text'>
                                <p>At Sentry, we offer specialized manufacturing business protection for:</p>
                                <ul>
                                    <li>Metalworking</li>
                                    <li>Electronic components</li>
                                    <li>Food processing</li>
                                    <li>Plastics and rubber goods</li>
                                    <li>Farm equipment</li>
                                    <li>Printing</li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={4} lg={4} xl={4}>
                        <div className='right-image'>
                            <img src={images['boots_Blue.svg']} alt="foot" />
                        </div>
                    </Col>
                </Row>
            </div>

            {/* policy cover */}
            <div className='common-top-data policy-cover-details' id='coverage'>
                <Row>
                    <Col sm={12} md={12} lg={12} xl={8}>
                        <div className='left-details'>
                            <div className='Heading'>
                                <h3>What does a manufacturing insurance policy cover?</h3>
                            </div>
                            <div className='text'>
                                <p>Our manufacturers coverage options are designed to meet your unique needs—helping minimize risk to your operations, employees, products, and equipment when the unexpected happens.</p>
                                <p>Here are a few options we offer:</p>
                                <ul>
                                    <li><strong>General liability:</strong> Our general liability insurance helps protect your large or small business from losses caused by your services, operations, or employees.</li>
                                    <li><strong>Workers’ compensation:</strong> From large or small deductible plans to self-insured workers’ compensation, we have a variety of policy options that can help you when an employee gets sick or injured on the job.</li>
                                    <li><strong>Business income insurance:</strong> If you’re forced to temporarily close your business after a property loss, this kind of coverage can help you cover things like payroll and operating expenses while business is interrupted.</li>
                                    <li><strong>Equipment breakdown coverage:</strong> We offer protection against breakdowns for mechanical equipment like engines, fans, and conveyers. We can also help protect electrical equipment like computers, generators, and motors, along with traditional boilers and machinery.</li>
                                    <li><strong>Cyber liability:</strong> Losing sensitive data can be just as devastating as physical property loss. Our cyber liability insurance will help cover you if confidential data is compromised at your company.</li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            {/* request bar columns */}
            <div className="request-bar-wrapper">
                <div className="featuredBarColumn">
                    <div className="heading">
                        <h3>How much does manufacturing insurance cost?</h3>
                    </div>
                    <div className='text'>
                       <p>Manufacturing insurance costs depend on a variety of risk factors. Every business is unique, so insurance costs are unique. Want more information on our custom policies?</p>
                    </div>
                    <a className="link primaryButtonLink" href='#/'>
                        <span>Request a quote</span>
                    </a>
                </div>
            </div>

            {/* property loss  */}
            <div className='common-top-data'>
                <Row>
                    <Col sm={12} md={12} lg={12} xl={8}>
                        <div className='left-details'>
                            <div className='Heading'>
                                <h3>Protecting your manufacturing property—before and after loss</h3>
                            </div>
                            <div className='text'>
                                <p>We’re here to help you when something happens, but we also want to help you reduce your overall risk exposure—for the good of your business and the safety of your employees.</p>
                                <p>We offer safety resources that can teach you how to identify hazards at your business—helping you control losses and avoid claims. Our specialized safety services include:</p>
                                <ul>
                                    <li>Loss trend analysis</li>
                                    <li>On-site safety and hazard assessments</li>
                                    <li>Workplace safety program development</li>
                                    <li>Best practice reviews and product liabilities</li>
                                    <li>Safety committee development</li>
                                    <li>Training resources</li>
                                </ul>
                            </div>
                            <NavLink to={''}>View resources</NavLink>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default ManufacturingInsurance